// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__K9tTp"};